import { Container, Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { productNameToTokenCategory } from "@utils/index";
import { ProductCategory } from "@utils/constants";
import BulkRequestItemComponent from "@components/organisms/BulkRequestItemComponent";
import { RequestType, StoneType } from "@scenes/bulk-request/Utils";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import DynamicForm from "../DynamicForm/DynamicForm";
import { memo, useMemo } from "react";
import { filterAndSortFormData } from "../DynamicForm/utils";
import { useUnifiedProductPagesSlice } from "@redux/slices/unifiedProductPages";
import { View } from "react-native";
import EditBulkItemButtons from "./EditBulkItemButton";
import { getNormalizeRequestType } from "@utils/product/productValidators";
import styled from "styled-components/native";
import { useTranslation } from "react-i18next";
import React from "react";
import OrderCartSummaryList from "@scenes/configurator/OrderCart/OrderCartSummaryList";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { DefaultTheme } from "styled-components/native";

const EditBulkItem = ({
  item,
  removeFromList,
  productType,
  handleEvent,
  requestType,
  fromRequestModify,
  stoneType,
  fromBulkList,
  saveBulkItemDetails,
  onClose,
}: any) => {
  const { t } = useTranslation();
  const { theme, typography, user } = useScreenOptionsHooks();
  const unifiedProductPagesSlice = useUnifiedProductPagesSlice();
  const { enableJewelryHybridMode } = useOrgSettingsSlice();
  const type = getNormalizeRequestType(requestType);
  const formData =
    stoneType === StoneType.PAIR
      ? unifiedProductPagesSlice?.unifiedProductData?.[productType]?.pair
          ?.bulkList?.bulkInit?.singleItemForm[type]
      : stoneType === StoneType.PARCELS
      ? theme.isMobile
        ? unifiedProductPagesSlice?.unifiedProductData?.[productType]?.parcels
            .mobile_parcels?.bulkList?.bulkInit?.singleItemForm[type]
        : unifiedProductPagesSlice?.unifiedProductData?.[productType]?.parcels
            ?.bulkList?.bulkInit?.singleItemForm[type]
      : unifiedProductPagesSlice?.unifiedProductData?.[productType]?.bulkList
          ?.bulkInit?.singleItemForm[type];
  const formdata = filterAndSortFormData(formData, user.price_mode);
  const productNameShort = productNameToTokenCategory(
    productType ?? ProductCategory.DIAMOND
  );
  const allowSkipDiscount: boolean =
    type === RequestType.QUOTE || type === RequestType.BUY;

  const RenderedItem = useMemo(
    () =>
      ({ mItem, i }: any) => {
        const isConfiguratorItem =
          !fromBulkList &&
          enableJewelryHybridMode &&
          mItem?.configuration_details?.config;

        return (
          <Overlay>
            {isConfiguratorItem ? (
              <OrderCartSummaryList
                itemList={[mItem]}
                priceMode={1}
                productType={productType}
                showRemoveIcon={false}
                orderCartRequest={true}
                setShowLoader={undefined}
                refetchCartData={undefined}
                openRemoveFromBulkPopupId={0}
              />
            ) : (
              <BulkRequestItemComponent
                key={i}
                mItem={
                  fromRequestModify
                    ? mItem
                    : {
                        ...mItem.item,
                        quantity: mItem?.quantity,
                        cart_item_id: mItem?.id,
                      }
                }
                productType={fromRequestModify ? mItem?.type : mItem.stock_type}
                editBulkItem={true}
                onCloseEditBulkItem={() => onClose && onClose(false)}
                stoneType={stoneType}
                onPress={() => {}}
                fromRequestModify={fromRequestModify}
                saveBulkItemDetails={saveBulkItemDetails}
              />
            )}

            <Spacer size={SpaceType.ExtraLarge} />
            {formdata?.length > 1 && (
              <>
                <VDBText type={typography["H3-M"]} color={theme["core-05"]}>
                  {t("bulkInitScreen.modal.screenText.text")}
                </VDBText>
                <Spacer size={SpaceType.Double} />
              </>
            )}
          </Overlay>
        );
      },
    [item]
  );

  return (
    <>
      <Spacer size={SpaceType.Extra} />
      <Container noPadding={!theme.isMobile}>
        <RenderedItem mItem={item} />
        <View
          style={{
            paddingHorizontal: !theme.isMobile ? SpaceType.Extra : 0,
          }}
        >
          <DynamicForm
            form={formdata}
            hideSubmitButton={true}
            minDate={new Date()}
            itemDetail={fromRequestModify ? item : item?.item}
            fromRequestModify={fromRequestModify}
            skipHasNullDiscount={allowSkipDiscount}
            fromRequestDetail={false}
            testIDPrefix={"bulk-init-screen.edit-item"}
          />
        </View>
        <Spacer size={SpaceType.Big} />
        <EditBulkItemButtons
          formdata={formdata}
          productNameShort={productNameShort}
          removeFromList={removeFromList}
          handleEvent={handleEvent}
          item={item}
          fromRequestModify={fromRequestModify}
          testIDPrefix={"bulk-init-screen.edit-item"}
        />
      </Container>
    </>
  );
};

const Overlay = styled.View`
  padding-horizontal: ${({ theme }: { theme: DefaultTheme }) =>
    theme.isMobile ? "0px" : "12px"};
`;

export default memo(EditBulkItem);
